import { staticEnv } from 'env';
import { ApiGConfig } from 'models';

export const config: ApiGConfig = {
  name: 'provisioning',
  endpoint: staticEnv.IS_PRODUCTION ? 'https://provisioning.prod.api.nwave.io' : 'https://provisioning.dev.api.nwave.io',
};
